import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PayorService {
  private payorChangeSubject = new BehaviorSubject<boolean>(false);
  private enterEditModeSubject = new BehaviorSubject<boolean>(false);

  get payorChange$(): Observable<boolean> {
    return this.payorChangeSubject.asObservable();
  }

  notifyPayorChange(): void {
    this.payorChangeSubject.next(true);
  }

  enterEditMode$ = this.enterEditModeSubject.asObservable();

  triggerEnterEditMode(): void {
    this.enterEditModeSubject.next(true);
  }
  
  resetEditMode():void{
    this.enterEditModeSubject.next(false);
  }
  resetPayorChange(): void{
    this.payorChangeSubject.next(false);
  }
}
